import 'angular-elastic';
import rpGuiGuide from 'rp-gui-guide';
import rpAdvertising from 'rp-advertising';
import { appPromo } from 'rp-navigation';
import popup, { backLink } from 'rp-popup';
import { cleanLegacy } from 'rp-cookie';
import initNavigationPrefs from 'rp-url-navigation-prefs';
import analyticsPage from './analyticsPage';
import jQuery from 'jquery';
import './modules/appResults';
import renderSecondaryNav from './services/secondaryNavConfig';
import initBookmakerRegPanel from 'rp-betting-special-offer';
import {
    STORAGE_ITEM_NAME,
    UPDATE_TARGETING
} from './config/storage';
import '../css/main.scss';

jQuery.cookie('to_force_inclusion_in_code');

analyticsPage();
renderSecondaryNav();
cleanLegacy();
popup();
backLink();
initBookmakerRegPanel();
rpGuiGuide({
    svg: { polyfill: true }
});
rpAdvertising({
    targeting: ['pedigree'],
    targetingEvent: UPDATE_TARGETING,
    localStorageKey: STORAGE_ITEM_NAME
});
initNavigationPrefs();
appPromo.init();



// WEBPACK FOOTER //
// ./src/js/index.js